@if(loading){
<div class="tw-flex tw-items-center tw-justify-center">
  <p-progressSpinner></p-progressSpinner>
</div>
}
@else {
@if(!business){
<brt-business-list (selected)="router.navigate([basePath, 'report', $event.Id])"></brt-business-list>
}
@else if(report){
<div class="card">
  <div class="tw-flex tw-justify-between">
    <div class="field">
      <label htmlFor="fromDate">From Date ({{(criteria.FromDate|date:'hh:mm a')||'00:00 AM'}})</label>
      <div class="tw-flex">
        <p-calendar [(ngModel)]="criteria.FromDate" (ngModelChange)="$event?.setHours(5,0,0,0)" />
      </div>
    </div>
    <div class="field">
      <label htmlFor="toDate">To Date ({{(criteria.ToDate|date:'hh:mm a')||'00:00 AM'}})</label>
      <div class="tw-flex">
        <p-calendar [(ngModel)]="criteria.ToDate" (ngModelChange)="$event?.setHours(5,0,0,0)" />
      </div>
    </div>
    <div class="field">
      <p-button label="Generate Report" icon="pi pi-file" class="tw-bg-green-500 tw-text-white" (click)="load()"
        [loading]="loading"></p-button>
    </div>
  </div>
</div>
<h5>Order Report</h5>
<div class="card">
  <div class="field">
    <label htmlFor="fromDate">From Date</label>
    <span class="tw-font-bold">{{report.Criteria.FromDate|date:'long'}}</span>
  </div>
  <div class="field">
    <label htmlFor="toDate">To Date</label>
    <span class="tw-font-bold">{{report.Criteria.ToDate|date:'long'}}</span>
  </div>
  <div class="field">
    <label htmlFor="quantity">Total Quantity</label>
    <span class="tw-font-bold">{{report.TotalQuantity}} order(s)</span>
  </div>
  <div class="field">
    <label htmlFor="payable">Total Amount</label>
    <span class="tw-font-bold">{{report.TotalAmount|currency:'&pound;'}}</span>
  </div>
</div>
<p-table [value]="report.Articles" [rowHover]="true" [loading]="loading" groupRowsBy="Type" rowGroupMode="subheader">
  <ng-template pTemplate="header">
    <tr>
      <th>Payment Type</th>
      <th>Quantity</th>
      <th>Amount</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="groupheader" let-customer>
    <tr pRowGroupHeader class="!tw-bg-slate-100">
      <td colspan="4" class="tw-font-bold tw-text-xl">{{customer.Type}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-article>
    <tr>
      <td class="tw-font-bold">
        {{article?.PaymentMethod || (article?.IsCash ? 'Cash' : 'Not specified')}}
      </td>
      <td>{{article.Quantity}} order(s)</td>
      <td class="tw-font-bold">{{article.Amount|currency:'&pound;'}}</td>
    </tr>
  </ng-template>
</p-table>

<!-- <h5>Orders</h5>
<p-table [value]="orders" [rowHover]="true" dataKey="id" [rows]="limit" [loading]="loading" [rowHover]="true"
  styleClass="p-datatable-gridlines" [paginator]="true" [totalRecords]="total" responsiveLayout="scroll" [lazy]="true"
  (onLazyLoad)="loadOrders($event)">
  <ng-template pTemplate="header">
    <tr>
      <th>Order Number</th>
      <th>Type</th>
      <th>Payment</th>
      <th>Order Time</th>
      <th>Subtotal Amount</th>
      <th>Commission Amount</th>
      <th>Used Balance</th>
      <th>Main Credit</th>
      <th>Business Credit</th>
      <th>Service Fee</th>
      <th>Restaurant Payable</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-order>
    <tr>
      <td class="tw-font-bold">{{order.Number}}</td>
      <td>{{order.Type}}</td>
      <td>{{order.Payment?.IsCash? 'Cash': 'Card'}}</td>
      <td>{{order.CompletedTime|date:'short'}}</td>
      <td>{{order.Subtotal|currency:'&pound;'}}</td>
      <td>{{order.CommissionAmount|currency:'&pound;'}}</td>
      <td>{{order.UsedBalance|currency:'&pound;'}}</td>
      <td>{{order.MainCredit|currency:'&pound;'}}</td>
      <td class="tw-bg-slate-100">{{order.BusinessCredit|currency:'&pound;'}}</td>
      <td>{{order.OnlinePaymentFee|currency:'&pound;'}}</td>
      <td class="tw-font-bold">{{order.TransactAmount|currency:'&pound;'}}</td>
    </tr>
  </ng-template>
</p-table> -->
}
}